export default {
  en: {
    contactPerson: 'Contact Person',
    newContactPerson: 'New Contact Person',
    name: 'Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    position: 'Position',
    phone: 'Phone',
    mobile: 'Mobile',
    fax: 'Fax',
    email: 'Email',
    primary: 'Primary',
    secondary: 'Secondary',
    stopSale: 'Stop Sale',
    updatePrioritySuccessTitle: 'Success',
    updatePrimarySuccessMessage: 'Update Primary Success',
    updateSecondarySuccessMessage: 'Update Secondary Success',
    confirmRemoveContactPersonTitle: 'Confirm',
    confirmRemoveContactPersonMessage: 'Confirm to delete <strong>{name}</strong>?',
    confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancel',
    removeContactPersonSuccess: 'Delete contact person success',
    updateStopSaleSuccessTitle: 'Success',
    updateStopSaleSuccessMessage: 'Update Stop Sale Success'
  },
  th: {
    contactPerson: 'ผู้ติดต่อ',
    newContactPerson: 'สร้างผู้ติดต่อ',
    name: 'ชื่อผู้ติดต่อ',
    firstName: 'ชื่อ',
    lastName: 'นามสกุล',
    position: 'ตำแหน่ง',
    phone: 'โทรศัพท์',
    mobile: 'มือถือ',
    fax: 'แฟกซ์',
    email: 'อีเมล',
    primary: 'Primary',
    secondary: 'Secondary',
    stopSale: 'ปิดขาย',
    updatePrioritySuccessTitle: 'Success',
    updatePrimarySuccessMessage: 'Update Primary Success',
    updateSecondarySuccessMessage: 'Update Secondary Success',
    confirmRemoveContactPersonTitle: 'ยืนยัน',
    confirmRemoveContactPersonMessage: 'กรุณายืนยันการลบ <strong>{name}</strong>?',
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    removeContactPersonSuccess: 'ลบผู้ติดต่อสำเร็จ',
    updateStopSaleSuccessTitle: 'สำเร็จ',
    updateStopSaleSuccessMessage: 'เปลี่ยนสถานะการขายสำเร็จ'
  }
}
